<template lang="pug">
  div
    el-card(shadow='hover').card-collapse
      el-col(:span='8').center
        app-display(label="Nome do Interessado:", :content="vtn.processoSicarf.nomeRazaoSocialInteressado")
        app-display(label="Número do processo:", :content="vtn.processoSicarf.numeroProcesso")
      el-col(:span='8')
        app-display(label="CPF do Interessado:", :content="vtn.processoSicarf.cpfCnpjInteressado")
        app-display(label="Tipo de Processo:", :content="vtn.processoSicarf.tipo.nome")
    el-card(shadow='hover').card-collapse
      el-row(shadow='hover').card-collapse
        el-col(:span='4')
          app-display(label="Tipo:", :content="vtn.formaPagamento === 'A_VISTA' ? 'À vista' : 'À prazo'")
      el-row(shadow='hover').card-collapse
        el-col(:span='6')
          app-display(label="Valor principal:", :content="formatReal(vtn.calculosVtn.vtn)")
        el-col(:span='6')
          app-display(label="Valor desconto:",v-if="vtn.formaPagamento === 'PARCELADO'", :content="formatReal(vtn.calculosVtn.descontoTemDireito + vtn.calculosVtn.descontoRespeita)")
          app-display(label="Valor desconto:",v-if="vtn.formaPagamento === 'A_VISTA'", :content="formatReal(vtn.calculosVtn.descontoAVista)")
        el-col(:span='8')
          app-display(label="Valor total:", :content="formatReal(vtn.calculosVtn.vtnComDesconto || vtn.calculosVtn.vtn)")
      el-row(shadow='hover').card-collapse
        el-col(:span='6')
          app-display(label="Status da VTN:", :content="vtn.statusVtn")
        el-col(:span='6')
          app-display(label="Quantidades de DAEs emitidos:", :content="vtn.boletos.length")
        el-col(:span='8')
          app-display(label="Prazo de carência:", v-if="vtn.formaPagamento === 'A_VISTA' && vtn.statusVtn === 'Em aberto'", :content="vtn.prazoCarencia + ' dia(s)'")
          app-display(label="Quantidade de parcelas:", v-if="vtn.formaPagamento === 'PARCELADO'", :content="vtn.quantidadeParcelas")
      el-table.table-boletos(
        :data="vtn.boletos",
        stripe
      )
        el-table-column(width="100" prop="numeroVia", label="Nº Via Dae")
        el-table-column(width="200" prop="dataCriacao", label="Data Emissão")
        el-table-column(width="200" prop="dataVencimento", label="Data Vencimento")
        el-table-column(prop="receita.tipoReceita.descricao", label="Receita")
        el-table-column(prop="situacao", label="Status", :formatter="formatSituacao")
        el-table-column(prop="valorPrincipal", label="Valor", :formatter="formatValor")
    el-button(type="default", @click="voltar", icon="el-icon-arrow-left") Voltar
  </template>

<script>

import AppDisplay from '@/components/AppDisplay'
import utils from '@/utils/utils'
import { mapActions } from 'vuex'

export default {
  components: {
    AppDisplay
  },

  data () {
    return {
      active: 0,
      vtn: {
        calculosVtn: {},
        boletos: [],
        processoSicarf: {
          nomeRazaoSocialInteressao: '',
          cpfCnpjInteressado: '',
          numeroProcesso: '',
          tipo: {
            nome: ''
          }
        }
      }
    }
  },

  async mounted () {
    const data = await this.url(this.$route.params.idProcesso)
    this.vtn = data
  },

  methods: {
    ...mapActions({
      url: 'vtn/getVtnProcessoId'
    }),

    voltar () {
      this.$router.push({
        name: 'DAE_VTN'
      })
    },

    formatValor (prop) {
      return `R$ ${utils.format(prop.valorPrincipal)}`
    },

    formatReal (valor) {
      return `R$ ${utils.format(valor)}`
    },

    formatSituacao (prop) {
      switch (prop.situacao) {
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'QUITADO':
          return 'Pago'
        case 'CANCELADO':
          return 'Cancelado'
        case 'AGUARDANDO_EMISSAO_BOLETO':
          return 'Aguardando Emissão do boleto'
        case 'VENCIDO':
          return 'Vencido'
        default:
          return '-'
      }
    }

  }
}
</script>

  <style scoped lang="scss">
  .card-collapse {
    border-radius: 10px;
    margin: 10px 0;
  }

  .label {
    font-weight: bold;
  }

  .table-boletos {
    width: 100%;
    margin: 20px 0;
  }
  </style>



// WEBPACK FOOTER //
// src/screens/analise/VisualizarDAEs.vue